// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1DMTa","colMin":"styles_colMin__3MMxW","colCheckbox":"styles_colCheckbox__PV4iC"};